export default "__VITE_ASSET__XvTsIEEt__"